import React, { useEffect, useState } from "react";
import axios from "axios";

import styled from "styled-components";

import { Spin, Table } from "antd";

import { handleError } from "../../../modules/presence/sagas";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
`;

const baseapi = process.env.REACT_APP_API + "/api";

const Sectors = ({ token, currentClientId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  const match = { client_id: currentClientId };
  const fetchSectors = async () => {
    setIsLoading(true);
    try {
      const result = await axios.post(
        `${baseapi}/refsectors`,
        {
          match
        },
        {
          headers: {
            Authorization: token
          }
        }
      );
      setData(result.data);
    } catch (e) {
      handleError(e);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    fetchSectors();
  }, [currentClientId]);
  const columns = [
    {
      title: "id",
      dataIndex: "id",
      key: "id",
      render: id => {
        return <span>{id}</span>;
      }
    },
    {
      title: "label",
      dataIndex: "label",
      key: "label",
      render: label => {
        return <span>{label}</span>;
      }
    }
  ];

  return (
    <Container>
      <HeaderContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <div style={{ fontSize: 30 }}>{`Liste des enseignes (sectors)`}</div>
        </div>
      </HeaderContainer>
      <React.Fragment>
        {isLoading ? (
          <Spin />
        ) : (
          <Table rowKey="_id" columns={columns} dataSource={data} pagination={false} align="center" />
        )}
      </React.Fragment>
    </Container>
  );
};

export default Sectors;



// WEBPACK FOOTER //
// src/containers/metier/referential/Sectors.js